import React, { useState, useRef } from 'react';
import axios from 'axios';
import InspectionsTable from './InspectionsTable';
import {
  Box,
  Typography,
  Button,
  Input,
  Paper,
  Alert
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InspectionsDashboard from './InspectionsDashboard';
import DriverViolationsGrid from './DriverViolationsGrid';
import { BASE_URL_API } from '../configs/urls';

export default function UploadXML() {
  const [file, setFile] = useState(null);
  const [msg, setMsg] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const dropRef = useRef();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMsg("");
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.name.endsWith(".xml")) {
      setFile(droppedFile);
      setMsg("");
    } else {
      setMsg("Solo se permiten archivos .xml");
    }
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleUpload = async () => {
    if (!file) {
      setMsg("Selecciona o arrastra un archivo XML");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(`${BASE_URL_API}/upload-xml`, formData);
      setMsg(res.data.message);
      setFile(null);
      setRefreshKey(prev => prev + 1);
    } catch (err) {
      console.error(err);
      setMsg("Error al subir el archivo");
    }
  };

  return (
    <Box sx={{ px: 0, py: 0, width: '100%', height: '100%' }}>
      <Typography variant="h5" align="center" gutterBottom>
        Sube el archivo de inspecciones FMCSA
      </Typography>

      <Paper
        ref={dropRef}
        elevation={3}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        sx={{
          p: 3,
          mb: 3,
          border: '2px dashed #90caf9',
          borderRadius: 2,
          textAlign: 'center',
          backgroundColor: '#f0f8ff',
          transition: 'background-color 0.2s',
          '&:hover': {
            backgroundColor: '#e3f2fd',
          },
        }}
      >
        <Typography variant="body1" gutterBottom>
          Arrastra y suelta un archivo XML aquí, o selecciona uno manualmente:
        </Typography>

        <label htmlFor="xml-upload">
          <Input
            id="xml-upload"
            type="file"
            inputProps={{ accept: ".xml" }}
            onChange={handleFileChange}
            sx={{ display: 'none' }}
          />
          <Button
            variant="outlined"
            component="span"
            startIcon={<CloudUploadIcon />}
            sx={{ my: 2 }}
          >
            Seleccionar archivo
          </Button>
        </label>

        {file && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            📄 Archivo seleccionado: <strong>{file.name}</strong>
          </Typography>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={handleUpload}
          disabled={!file}
          sx={{ mt: 2 }}
        >
          Subir archivo
        </Button>

        {msg && (
          <Alert
            severity={msg.toLowerCase().includes("error") ? "error" : "success"}
            sx={{ mt: 2 }}
          >
            {msg}
          </Alert>
        )}
      </Paper>

        <InspectionsTable refresh={refreshKey} setRefresh={setRefreshKey} />

        {/* <DriverViolationsGrid
            driverName="JORGE EDUARDO ALATORREHUERTA"
            startDate="2025-07-01"
            endDate="2025-08-01"
        />  */}
        
        <InspectionsDashboard refresh={refreshKey}  />
        { /*<BehaviorAnalysis/> */}
        { /*<ViolationTrends/>*/}
    </Box>
  );
}